import appsettings from "@/store/app-settings";
import { axiosGet, axiosPost } from "@/store/api/axiosUtils.js";

const getComplaintForDivision = (params) => {
  return axiosGet(
    appsettings.ocpbComplaintAPIUrl + "api/Complaint/ComplaintForDivision",
    params
  );
};

const ComplaintEditAdmin = (params) => {
  return axiosGet(
    appsettings.ocpbComplaintAPIUrl + "api/Complaint/ComplaintEditAdmin",
    params
  );
};

const GetComplaintForSearch = (params) => {
  return axiosGet(
    appsettings.ocpbComplaintAPIUrl + "api/Complaint/ComplaintForSearch",
    params
  );
};

const GetComplaintForHistorySearch = (params) => {
  return axiosGet(
    appsettings.ocpbComplaintAPIUrl + "api/Complaint/ComplaintForHistorySearch",
    params
  );
};

const GetComplaintForUserHistorySearch = (params) => {
  return axiosGet(
    appsettings.ocpbComplaintAPIUrl + "api/Complaint/ComplaintForUserHistorySearch",
    params
  );
};

const GetGroupComplaint = (params) => {
  return axiosGet(
    appsettings.ocpbComplaintAPIUrl + "api/Complaint/GetGroupComplaint",
    params
  );
};


const getComplaintForNotiAdmin = (params) => {
  return axiosGet(
    appsettings.ocpbComplaintAPIUrl + "api/Complaint/ComplaintForNotiAdmin",
    params
  );
};

const getComplaintForNotiScreening = (params) => {
  return axiosGet(
    appsettings.ocpbComplaintAPIUrl + "api/Complaint/ComplaintForNotiScreening",
    params
  );
};

const postAdminComplaintRecieveDate = (params) => {
  return axiosPost(
    appsettings.ocpbComplaintAPIUrl + "api/Complaint/ComplaintAdminRecieveDate",
    params
  );
};

const getComplaintCancelListScreening = () => {
  return axiosGet(
    appsettings.ocpbComplaintAPIUrl + "api/Complaint/ComplaintCancelListScreening",
  );
}

const getComplaintScreeningHistory = (params) => {
  return axiosGet(
    appsettings.ocpbComplaintAPIUrl + "api/Complaint/ComplaintScreeningHistory",
    params
  );
};

export {
  getComplaintForDivision,
  GetGroupComplaint,
  GetComplaintForSearch,
  getComplaintForNotiAdmin,
  getComplaintForNotiScreening,
  postAdminComplaintRecieveDate,
  GetComplaintForHistorySearch,
  GetComplaintForUserHistorySearch,
  ComplaintEditAdmin,
  getComplaintCancelListScreening,
  getComplaintScreeningHistory,
};
